import api, { ApiResponse, PageResponse } from './api'
import type { BillingInterval, Product, ProductType, SubscriptionPlanProviderCode } from '../types'

interface ProductListParams {
  page?: number
  size?: number
  status?: string
}

interface CreateProductRequest {
  name: string
  description?: string
  price: string
  currency: string
  productType: ProductType
  billingInterval?: BillingInterval
  billingIntervalCount?: number
  totalBillingCycles?: number | null
  providerCode?: SubscriptionPlanProviderCode
  metadata?: Record<string, string>
}

interface UpdateProductRequest {
  name?: string
  description?: string
  price?: string
  currency?: string
  metadata?: Record<string, string>
}

export function getProducts(params: ProductListParams): Promise<ApiResponse<PageResponse<Product>>> {
  return api.get('/v1/merchant/products', { params })
}

export function getProduct(id: string): Promise<ApiResponse<Product>> {
  return api.get(`/v1/merchant/products/${id}`)
}

export function createProduct(data: CreateProductRequest): Promise<ApiResponse<Product>> {
  return api.post('/v1/merchant/products', data)
}

export function updateProduct(id: string, data: UpdateProductRequest): Promise<ApiResponse<Product>> {
  return api.patch(`/v1/merchant/products/${id}`, data)
}

export function archiveProduct(id: string): Promise<ApiResponse<null>> {
  return api.delete(`/v1/merchant/products/${id}`)
}
